<script>
import Layout from '@layouts/main'

import Datatable from '@components/Datatable';
import Downloader from 'download-in-browser';
import SharePlaylistPopup from './share_playlist_popup';

import {AxiosHelper} from '@src/utils/utils';
import { simpleComputed } from '@state/helpers'
import { getAudioDB, remotePlayer } from '@utils/lidb';

export default {
	components: { Layout, Datatable, SharePlaylistPopup },
  data() {
    return {
			playlist : [],
			selectedPlaylist : '-',
			tableData : [],
			sharePlaylistOpen : false,

			db : getAudioDB(),
			tableOption : {
				// scrollY: 440,
				paging: false,
				columns : [
					{data : 'time'},
					{data : 'artist'},
					{data : 'title'},
					{data : 'action'}
				],
				columnDefs : [
					{
						visible : false, targets : [0]
					},
					{
						render : function(data, type, row) {
							return `
								<div class="button-list">
									<button type="button" data-type="remove" class="btn btn-danger btn-xs waves-effect waves-light">삭제</button>
									<button type="button" data-type="download" class="btn btn-blue btn-xs waves-effect waves-light">다운로드</button>
								</div>
							`;
						},
						targets : 3
					}
				]
			},


    }
	},
	computed : {
		...simpleComputed,
	},
	mounted() {
		this.listView();
		this.loadFromIndexedDB();
	},
	methods : {
		loadFromIndexedDB() {
			(async () => {
				this.tableData = await this.db.select();
			})();
		},

		listView() {
			AxiosHelper.get('/api/music/playlist').then(ret => {
				this.playlist = ret.data;
			});
		},

		changePlaylist(event) {
			if(this.selectedPlaylist === '-') {
				return;
			}
	
			this.loadList();
		},

		removeListName() {
			const val = this.selectedPlaylist;
			if(val === '-') {
				this.pushMessage('기본재생목록은 삭제 불가');
				return;
			}

			AxiosHelper.get(`/api/music/playlist/${this.selectedPlaylist}/delete`).then(ret => {
				this.pushMessage('삭제완료');
				this.listView();
			});
		},

		loadList() {
			AxiosHelper.get(`/api/music/playlist/${this.selectedPlaylist}`).then(ret => {
				this.tableData = ret.data;
			});
		},

		tableClick(index, data, event) {
			event.preventDefault();
			event.stopPropagation();

			if(event.target.dataset.type === 'download') {
				Downloader(`${AxiosHelper.baseUrl()}${data.mp3}?proc=download`);
			}
			else if(event.target.dataset.type === 'remove') {
				this.db.deleteItem(data.time);
				// this.loadFromIndexedDB();
			}
		},

		setCurlist() {
			this.db.setList(this.tableData);
			remotePlayer('remocon_list_changed', null, this.tableData);
			this.playerOpen();
		},

		addCurlist() {
			this.db.insertList(this.tableData);
			remotePlayer('remocon_list_added', null, this.tableData);
		},
		
		fileListDown() {
			Downloader(`${AxiosHelper.baseUrl()}/api/music/playlist/down?list=${encodeURIComponent(JSON.stringify(this.state.tableData))}`);
		},

		toggleSharePlaylist() {
			this.$refs.sharePlaylistPopup.show();
		},

		saveList() {
			this.progressShow();
		},

	}
}
</script>

<template>
  <Layout>
		<C.PageHeader title="플레이리스트 관리"/>

		<C.Row>
			<C.Col lg="3">
				<div class="form-row">
					<div class="form-group col-lg-8">
						<select v-model="selectedPlaylist" class="form-control"
							@change="changePlaylist"
						>
							<option value='-'>현재재생목록</option>
							<option v-for="v in playlist" :key="v.idx" :value="v.idx">{{v.listname}}</option>
						</select>
					</div>
					<div class="form-group col-lg-4">
						<button type="button" class="btn btn-danger waves-effect waves-light"
							@click="removeListName">삭제</button>
					</div>
				</div>
			</C.Col>
			<C.Col lg="9">
				<C.FormGroup class="button-list text-right">
					<button type="button"  class="btn btn-blue waves-effect waves-light"
						@click="saveList">리스트 저장</button>
					<button type="button" class="btn btn-blue waves-effect waves-light"
						@click="setCurlist">현재 리스트로 플레이</button>
					<button type="button" class="btn btn-blue waves-effect waves-light"
						@click="addCurlist">현재 리스트에 추가</button>
					<button type="button" class="btn btn-info waves-effect waves-light"
						@click="fileListDown">음악목록 mp3 다운로드</button>
					<button type="button" class="btn btn-info waves-effect waves-light"
						@click="toggleSharePlaylist">외부공유</button>
				</C.FormGroup>
			</C.Col>
		</C.Row>

		<C.Row>
			<C.Col lg="12">
				<C.Card>
					<C.CardHeader class="bg-warning text-white">
						플레이리스트를 저장/불러오고 mp3로 다운로드 할수 있다.
					</C.CardHeader>
					<C.CardBody>
						<Datatable :option="tableOption" :data="tableData"
							@clickHandler="tableClick"
						>
							<template v-slot:thead>
								<tr>
									<th>time</th>
									<th>가수</th>
									<th>제목</th>
									<th>기타</th>
								</tr>
							</template>
						</Datatable>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>

		<SharePlaylistPopup 
			ref="sharePlaylistPopup"
			:data="tableData"
		/>
  </Layout>
</template>